import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "reflect-metadata";
import "widgets/eshop";
import "widgets/multiEshop";
import "widgets/customerReview";
import "widgets/exemption";
import "widgets/chargeManagement";
import "widgets/chargeTypes";
import "widgets/priceList";
import "widgets/notice";
import "widgets/omission";
import "widgets/paymentValidation";
import "widgets/tradingPlaces";
import "widgets/tollRoads";
import "widgets/kiosk";
import "widgets/outages";
import "widgets/refundRequest";
import initializeAnalytics from "./utils/analytics";

import { getWidgetById } from "./widgets/widget";
import "views";
import * as serviceWorker from "serviceWorker";
import ReactDOM from "react-dom";
import React from "react";
import { monkeyPatchHashNavigationAdapter } from "./utils/urlAdapterPath";
import { monkeyPatchValidationControlBase } from "utils/validationPatch";
import initializeSentry from "./utils/sentryUtils";

initializeSentry();

monkeyPatchValidationControlBase();
monkeyPatchHashNavigationAdapter();

const roots = document.querySelectorAll<HTMLElement>("[data-react-component]");

roots.forEach((root: HTMLElement) => {
  const componentId = root.dataset.reactComponent || "";
  const Component = getWidgetById(componentId);

  ReactDOM.render(<Component />, root);
});

initializeAnalytics();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
